// src/hooks/useFirebaseImage.js

import { useState, useEffect } from 'react';
import { ImageService, getCachedSync } from '../services/imageService';

export const useFirebaseImage = (fileName, fallbackUrl) => {
    // Inicialização SÍNCRONA: se a URL já estiver em cache, retorna imediatamente
    // sem esperar o efeito assíncrono — elimina o "piscar" de imagens no reload.
    const [url, setUrl] = useState(() => {
        if (!fileName) return fallbackUrl;
        if (fileName.startsWith('http')) return fileName;
        return getCachedSync(fileName) || null;
    });

    useEffect(() => {
        if (!fileName) {
            setUrl(fallbackUrl);
            return;
        }
        if (fileName.startsWith('http')) {
            setUrl(fileName);
            return;
        }

        // Se já temos URL do cache síncrono, não precisa fazer nada
        if (url && !url.startsWith('blob:')) return;

        let cancelled = false;
        ImageService.getUrl(fileName).then(resolved => {
            if (!cancelled) setUrl(resolved || fallbackUrl);
        });

        return () => { cancelled = true; };
    }, [fileName, fallbackUrl]); // eslint-disable-line react-hooks/exhaustive-deps

    return url || fallbackUrl;
};
